import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";
// import { Image_Fragment } from "./image";
// import { SellingPlanGroup_Fragment } from "./selling-plan-group";

export const BaseCartLine_Product_Fragment = graphqlShopifyStorefront(
  `
  fragment BaseCartLine_Product on Product {
    handle
    id
    featuredImageMasked: featuredImage {
      ...Image
    }
    sellingPlanGroupsConnectionMasked: sellingPlanGroups(first: 1) {
      edges {
        node {
          ...SellingPlanGroup
        }
      }
    }
    title
  }
`,
  // [Image_Fragment, SellingPlanGroup_Fragment],
);

export const BaseCartLine_Fragment = graphqlShopifyStorefront(
  `
  fragment BaseCartLine on BaseCartLine {
    cost {
      amountPerQuantity {
        amount
        currencyCode
      }
      subtotalAmount {
        amount
        currencyCode
      }
      totalAmount {
        amount
        currencyCode
      }
    }
    id
    merchandise {
      ... on ProductVariant {
        id
        imageMasked: image {
          ...Image
        }
        productMasked: product {
          ...BaseCartLine_Product
        }
        title
        selectedOptions {
          name
          value
        }
      }
    }
    quantity
  }
`,
  // [Image_Fragment, BaseCartLine_Product_Fragment],
);
